import axios from 'axios';

const axiosServices = axios.create({ baseURL: `/` });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
    async (config) => {

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // Preserva o objeto error completo para que error.response.status esteja disponível
    return Promise.reject(error);
  }
);

export default axiosServices;